import { z } from 'zod'
import { createProductPagesRequestSchema } from './create-product-pages-request'
import { productFileSchema } from './product-file'

/**
 * 產品子網頁 - 更新 Request Schema
 */
export const updateProductPagesRequestSchema = createProductPagesRequestSchema
  .merge(
    z.object({
      /** 刪除的檔案 ID */
      filesDelete: z.array(z.number()),
      /** 檔案上傳 - 原始檔 */
      files: z.object({
        en: z.array(productFileSchema),
        zh: z.array(productFileSchema)
      })
    })
  )
  .partial()

/**
 * 產品子網頁 - 更新 Request
 */
export interface UpdateProductPagesRequest
  extends z.infer<typeof updateProductPagesRequestSchema> {}
